export default defineNuxtPlugin({
  name: 'authorization-resolver',
  parallel: true,
  setup() {
    return {
      provide: {
        authorization: {
          resolveClientUser: () => {
            const { user } = useOidcAuth();
            return user.value ?? null;
          },
        },
      },
    };
  },
});
